// KPI-28 — kataloğa dosyadan içe aktarma modalı: UI kopyası TEK kaynak (kpi-import-copy kalıbı).
// Bileşenlerde satır içi durum/sonuç string'i yazılmaz.

export const KPI_CATALOG_IMPORT_COPY = {
  button: "Dosyadan içe aktar",
  kicker: "Katalog",
  title: "Dosyadan gösterge içe aktar",
  description:
    "Excel (.xlsx), Word (.docx) veya PDF tablosundaki satırlar kataloğa gösterge tanımı olarak eklenir. Değer aktarılmaz; müşteri veri setlerine dokunulmaz.",
  steps: ["Yükle", "Gözden geçir", "Sonuç"] as const,
  upload: {
    closeLocked:
      "Analiz sürerken pencere kapatılamaz — bitince (ya da hata verirse) kapatabilirsiniz.",
    dropLabel: "Dosya seç",
    dropHint:
      "Excel (.xlsx) · Word (.docx) · PDF (en fazla 8 sayfa) — en fazla 40 MB, 750 satır. Bant/başlık satırları kategori, değer satırları gösterge olur.",
    rejectType: "Yalnız .xlsx, .docx ve .pdf yüklenebilir",
    rejectSize: "Dosya 40 MB sınırını aşıyor",
    analyzing: "Dosya okunuyor ve yapay zekâ satırları kataloğa göre öneriyor…",
    analyzingHint: "(≤ 1 dk — satır sayısına göre)",
    analyzingHintPdf: "(PDF: tabloyu yapay zekâ okuyor — 1–3 dk sürebilir)",
    failed: "Dosya çözümlenemedi",
    retry: "Yeniden dene",
  },
  review: {
    /** D9 — birim hücresi rozetleri */
    unitAlternatives: (n: number): string => `+ ${n.toString()} alternatif`,
    unitTemplateHint: "şablon",
    unitTemplateTitle: "Birim şablonu: hesaplanan göstergenin birimi bileşenlerinden çözülür",
    summary: (s: {
      rows: number;
      categories: number;
      create: number;
      mapExisting: number;
      skip: number;
    }): string =>
      `${s.rows.toString()} satır · ${s.categories.toString()} kategori · ${s.create.toString()} yeni · ${s.mapExisting.toString()} mevcut · ${s.skip.toString()} atlanacak`,
    searchPlaceholder: "Satırlarda ara…",
    filterAll: "Tümü",
    filterCreate: "Yeni",
    filterMapExisting: "Mevcut",
    filterSkip: "Atlanacak",
    filterIssues: "Sorunlu",
    filterCategory: "Kategoriler",
    columns: {
      row: "Dosyadaki satır",
      action: "Karar",
      code: "Kod",
      label: "Etiket",
      unit: "Birim",
      category: "Üst kategori",
      type: "Tür",
      confidence: "Güven",
    },
    /** K-U1 — dosyada sütun varsa (en az bir satır doluysa) çizilen salt-okunur sütunlar. */
    descriptionColumn: "Açıklama",
    requirementsColumn: "Standart eşlemesi",
    actions: { create: "Yeni gösterge", map_existing: "Mevcut gösterge", skip: "Atla" },
    kinds: {
      category: "Kategori",
      metric: "Gösterge",
      breakdown_group: "Kırılım grubu",
      breakdown_member: "Kırılım üyesi",
    },
    /** spec §7.3 — grup/üye satırı rozeti (soluk pill) ve üst sütununda yol ipucu. */
    breakdownBadge: "kırılım",
    breakdownBadgeTitle:
      "Bu satır bir göstergenin kırılımı olarak eklenir (grup ya da grubun üyesi).",
    breakdownParentHint: "üst gösterge",
    noCategory: "— (kök)",
    derivedPill: "ƒx",
    updateLabel: "Etiket/birimi dosyadakiyle güncelle",
    existingDiff: (ex: { label: string; unit: string | null }): string =>
      `Katalogda: ${ex.label}${ex.unit ? ` (${ex.unit})` : ""}`,
    confidenceHigh: "yüksek",
    confidenceMedium: "orta",
    confidenceLow: "düşük",
    issueEmptyLabel: "Etiket boş",
    issueDuplicateCode: "Kod dosyada iki kez",
    issueCodeTaken: "Kod katalogda var — mevcut göstergeye eşleyin",
    issueBadCategory: "Üst kategori bulunamadı",
    issueBadBreakdownParent: "Kırılımın üstü bulunamadı (gösterge ya da kırılım grubu olmalı)",
    issueFormula: "Formül geçersiz",
    blockers: (n: number): string =>
      `${n.toString()} satırda sorun var — düzeltin ya da satırı atlayın`,
    empty: "Süzgece uyan satır yok.",
    pageInfo: (from: number, to: number, total: number): string =>
      `${from.toString()}–${to.toString()} / ${total.toString()}`,
    prev: "Önceki",
    next: "Sonraki",
    back: "Başka dosya",
    commit: "Kataloğa yaz",
    committing: "Yazılıyor…",
    nothingToWrite:
      "Yazılacak satır yok — en az bir satır 'Yeni' ya da güncellenecek 'Mevcut' olmalı",
  },
  result: {
    title: "Kataloğa yazıldı",
    summary: (r: {
      createdCategories: number;
      createdMetrics: number;
      updated: number;
      mapped: number;
      skipped: number;
    }): string =>
      `${r.createdCategories.toString()} kategori · ${r.createdMetrics.toString()} yeni gösterge · ${r.updated.toString()} güncellendi · ${r.mapped.toString()} mevcut · ${r.skipped.toString()} atlandı`,
    note: "Veri setleri değişmedi — yeni göstergeleri veri setlerine eklemek için veri seti düzenleyicisini kullanın.",
    close: "Kapat",
    again: "Başka dosya aktar",
  },
  errors: {
    codeTaken: (code: string): string => `Kod zaten katalogda: ${code}`,
    generic: "İçe aktarma başarısız",
  },
} as const;
